"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSnackbarContent = void 0;
var _colors_1 = require("./_colors");
exports.MuiSnackbarContent = {
    root: {
        variantSuccess: {
            backgroundColor: _colors_1.variantSuccess,
        },
        variantError: {
            backgroundColor: _colors_1.variantError,
        },
        variantInfo: {
            backgroundColor: _colors_1.variantInfo,
        },
        variantWarning: {
            backgroundColor: _colors_1.variantWarning,
        },
    },
};
